import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import PropertiesOverview from "./PropertiesOverview";
import useComponentType from "./useComponentType";
import { useSuspenseBIMClass } from "../../../../../../clients/taxonomy/useBIMClass";
import * as UI from "../../../../../../modules/ui-kit";
import ProductContainer from "../../entities/product/ProductContainer";

const Styled = styled.div`
    background: #6661;
    border-radius: 4px;
    padding: 8px 16px;
    transition: 200ms;

    .basics {
        display: grid;
        gap: 16px 32px;
        grid-auto-flow: row;
        grid-template-columns: 2fr 3fr 1fr;

        & > div {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .component-type {
            font-family: var(--font-mono), monospace;

            .name {
                font-size: 1.6em;
                letter-spacing: -0.04em;
            }

            .bimclass {
                font-size: 0.8em;
                letter-spacing: -0.04em;
            }
        }

        .amount {
            font-size: 2.4em;
        }
    }

    .properties {
    }

    .buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
        justify-content: flex-end;
    }

    &:hover {
        background: #2221;
    }
`;

export default function ComponentCard(props) {
    const {
        bimClassID,
        componentTypeID,
        onEdit,
        onRemove,
        product,
        properties,
        quantity,
        unitOfMeasurement,
    } = props;

    const componentType = useComponentType(componentTypeID, bimClassID);
    const componentTypeBIMClass = useSuspenseBIMClass(
        componentType?.bimClass?.id,
    ).data?.bimClass;

    const { i18n } = useTranslation();

    return (
        <Styled>
            <div className="basics">
                <div className="component-type">
                    <span className="name">
                        {t9n(componentType?.name, i18n.language)}
                    </span>
                    <span className="bimclass">
                        {t9n(componentTypeBIMClass?.data?.name, i18n.language)}{" "}
                        [{componentTypeBIMClass?.data?.type}]
                    </span>
                </div>
                <ProductContainer
                    brandID={product?.brand?.id}
                    id={product?.id}
                    naturalKey={product?.naturalKey}
                    href={(p) =>
                        `/products/Product/${p.id.replaceAll("-", "")}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                />
                <div className="amount">
                    {quantity} {unitOfMeasurement}
                </div>
            </div>
            {properties && (
                <PropertiesOverview
                    className="properties"
                    properties={properties}
                />
            )}
            <div className="buttons">
                <UI.Button onClick={onEdit}>Change</UI.Button>
                <UI.Button onClick={onRemove}>Remove</UI.Button>
            </div>
        </Styled>
    );
}
